var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisabledStaking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 134,
    viewBox: "0 0 134 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2005_2166",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 134,
    height: 134
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 134,
    height: 134,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2005_2166)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3437 12.2732C70.3437 13.2698 69.5359 14.0776 68.5393 14.0776L52.1865 14.0776C48.6039 14.0776 46.0254 14.079 44.0003 14.2445C41.9962 14.4082 40.6934 14.7236 39.6332 15.2638C37.5854 16.3072 35.9205 17.9721 34.8771 20.0199C34.3369 21.0801 34.0215 22.3829 33.8578 24.387C33.6923 26.4122 33.6909 28.9906 33.6909 32.5732L33.6909 41.7503L39.0689 36.3723C39.7736 35.6676 40.9161 35.6676 41.6208 36.3723C42.3254 37.077 42.3254 38.2195 41.6208 38.9242L33.1624 47.3825C32.824 47.7209 32.365 47.911 31.8865 47.911C31.4079 47.911 30.9489 47.7209 30.6105 47.3825L22.1522 38.9242C21.4475 38.2195 21.4475 37.077 22.1522 36.3723C22.8569 35.6676 23.9994 35.6676 24.7041 36.3723L30.082 41.7503L30.082 32.4922C30.082 29.0079 30.082 26.2824 30.2609 24.0931C30.4428 21.8659 30.8189 20.0353 31.6616 18.3815C33.0509 15.6547 35.2679 13.4377 37.9948 12.0483C39.6486 11.2056 41.4792 10.8296 43.7064 10.6476C45.8957 10.4687 48.6212 10.4687 52.1055 10.4687L68.5393 10.4687C69.5359 10.4687 70.3437 11.2766 70.3437 12.2732Z",
    fill: "url(#paint0_linear_2005_2166)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1563 115.74C66.1563 114.744 66.9641 113.936 67.9607 113.936L84.3135 113.936C87.8961 113.936 90.4746 113.935 92.4997 113.769C94.5038 113.605 95.8066 113.29 96.8668 112.75C98.9146 111.706 100.58 110.042 101.623 107.994C102.163 106.934 102.478 105.631 102.642 103.627C102.808 101.601 102.809 99.0231 102.809 95.4404L102.809 86.2634L97.4311 91.6414C96.7264 92.3461 95.5839 92.3461 94.8792 91.6414C94.1746 90.9367 94.1746 89.7942 94.8792 89.0895L103.338 80.6312C103.676 80.2928 104.135 80.1026 104.614 80.1026C105.092 80.1026 105.551 80.2928 105.889 80.6312L114.348 89.0895C115.052 89.7942 115.052 90.9367 114.348 91.6414C113.643 92.3461 112.501 92.3461 111.796 91.6414L106.418 86.2634L106.418 95.5215C106.418 99.0057 106.418 101.731 106.239 103.921C106.057 106.148 105.681 107.978 104.838 109.632C103.449 112.359 101.232 114.576 98.5052 115.965C96.8514 116.808 95.0208 117.184 92.7936 117.366C90.6043 117.545 87.8788 117.545 84.3945 117.545L67.9607 117.545C66.9641 117.545 66.1563 116.737 66.1563 115.74Z",
    fill: "url(#paint1_linear_2005_2166)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6219 74.0512C41.5221 74.0512 44.4222 74.026 47.3224 74.0764C47.8268 74.0764 48.4825 74.3284 48.8355 74.7064C51.1809 76.9995 53.5263 79.2926 55.7707 81.6865C62.2772 88.6161 64.3199 96.7554 61.3693 105.777C58.4439 114.773 52.114 120.316 42.7578 122.105C27.5508 125.003 13.403 112.328 14.4622 96.9065C14.8657 91.0352 17.1102 86.0207 21.1452 81.8125C23.4653 79.3934 25.8359 76.9995 28.2569 74.656C28.61 74.3032 29.2657 74.0764 29.7953 74.0764C32.7207 74.026 35.6713 74.0512 38.6219 74.0512ZM30.7032 102.223C31.0058 106.029 33.099 108.221 36.7053 109.229C36.7053 110.464 36.7053 111.673 36.7053 112.883C37.9914 112.883 39.1263 112.883 40.4124 112.883C40.4124 112.076 40.4629 111.371 40.3872 110.665C40.2611 109.607 40.5637 109.078 41.6986 108.725C44.7501 107.742 46.6667 104.542 46.2884 101.417C45.9102 98.0909 43.3378 95.5206 40.0089 95.1678C39.1263 95.067 38.2436 95.1174 37.3609 95.0418C35.7217 94.8654 34.5112 93.5047 34.486 91.9172C34.4356 90.3045 35.5956 88.9185 37.2096 88.6413C40.2107 88.1122 41.4968 88.8177 42.7326 91.766C43.8926 91.766 45.0527 91.766 46.5406 91.766C46.1119 90.506 45.8345 89.3721 45.3301 88.3641C44.3214 86.3734 42.4804 85.3907 40.3872 84.8111C40.3872 84.3827 40.3872 84.0552 40.3872 83.7024C40.3872 80.7037 40.3872 80.6785 37.4366 81.0061C37.134 81.0313 36.7053 81.5101 36.6548 81.8125C36.5539 82.7952 36.6296 83.8032 36.6296 84.7859C36.2261 84.9119 35.9487 85.0127 35.6713 85.1135C32.3424 86.2223 30.2744 89.3973 30.7536 92.6983C31.2328 96.1758 33.9564 98.6453 37.5123 98.8469C38.2688 98.8973 39.0254 98.8469 39.782 98.9477C41.4212 99.1744 42.556 100.586 42.5308 102.198C42.5056 103.811 41.2951 105.147 39.6811 105.373C36.6044 105.802 35.4191 105.121 34.3095 102.223C33.1494 102.223 31.9893 102.223 30.7032 102.223Z",
    fill: "url(#paint2_linear_2005_2166)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3672 57.998C33.8495 57.998 43.2057 57.998 52.6628 57.998C51.3514 61.5763 49.9896 65.0537 48.7791 68.5564C48.3251 69.8667 47.7703 70.3455 46.3076 70.3203C40.936 70.2195 35.5392 70.2447 30.1675 70.2951C29.2344 70.2951 28.7553 70.0683 28.4274 69.1359C27.1665 65.4569 25.7542 61.7779 24.3672 57.998Z",
    fill: "url(#paint3_linear_2005_2166)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1349 57.8357C83.4299 57.9804 72.8936 47.2731 72.9298 34.5221C72.9659 21.9338 83.4661 11.335 96.2434 11.3712C108.84 11.3893 119.467 21.9338 119.394 34.7753C119.322 47.3635 108.822 58.0346 96.1349 57.8357ZM106.942 25.1713C106.87 24.6287 106.599 24.1946 106.039 23.9595C105.352 23.6701 104.882 24.0318 104.43 24.4659C98.2856 30.6153 92.1228 36.7648 85.9782 42.9323C85.2372 43.6739 85.201 44.3793 85.7794 44.9942C86.3758 45.5911 87.0987 45.573 87.8396 44.8314C94.0204 38.6639 100.183 32.4783 106.346 26.3107C106.671 25.9852 106.924 25.6596 106.942 25.1713ZM94.8879 27.8662C94.8698 24.8638 92.412 22.404 89.4119 22.4221C86.4842 22.4402 83.9179 25.0447 83.954 27.9566C84.0082 30.959 86.4661 33.3464 89.5023 33.3464C92.5746 33.3283 94.906 30.9771 94.8879 27.8662ZM97.4181 41.3045C97.4181 44.3973 99.7314 46.7305 102.822 46.7305C105.912 46.7305 108.244 44.3793 108.244 41.3045C108.244 38.1936 105.93 35.8785 102.822 35.8785C99.7494 35.8966 97.4181 38.2117 97.4181 41.3045Z",
    fill: "url(#paint4_linear_2005_2166)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4321 25.1525C91.0044 25.1345 92.2333 26.3643 92.2333 27.9379C92.2153 29.4572 91.0225 30.669 89.4863 30.687C87.9321 30.7051 86.7031 29.4752 86.7031 27.9017C86.7212 26.3643 87.8959 25.1706 89.4321 25.1525Z",
    fill: "url(#paint5_linear_2005_2166)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.869 38.5568C104.442 38.5568 105.652 39.8229 105.616 41.3964C105.58 42.9157 104.369 44.1094 102.833 44.1094C101.261 44.1094 100.068 42.8615 100.086 41.2698C100.122 39.7325 101.333 38.5388 102.869 38.5568Z",
    fill: "url(#paint6_linear_2005_2166)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2005_2166",
    x1: 70.3437,
    y1: 29.1899,
    x2: 21.6237,
    y2: 29.1899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8845B",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0603A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2005_2166",
    x1: 66.1563,
    y1: 98.8238,
    x2: 114.876,
    y2: 98.8238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8845B",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0603A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2005_2166",
    x1: 38.5486,
    y1: 74.0449,
    x2: 38.5486,
    y2: 122.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3ABF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7770E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2005_2166",
    x1: 38.515,
    y1: 57.998,
    x2: 38.515,
    y2: 70.3212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3ABF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7770E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2005_2166",
    x1: 96.1622,
    y1: 11.3711,
    x2: 96.1622,
    y2: 57.8384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3ABF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7770E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2005_2166",
    x1: 89.4682,
    y1: 25.1523,
    x2: 89.4682,
    y2: 30.6872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3ABF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7770E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2005_2166",
    x1: 102.852,
    y1: 38.5566,
    x2: 102.852,
    y2: 44.1094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3ABF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7770E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledStaking);
export default __webpack_public_path__ + "static/media/disabledStaking.04b5af12a657e414b756b236c17cce23.svg";
export { ForwardRef as ReactComponent };